/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener("DOMContentLoaded", () => {
  // Select all the SVG icons within the grid
  const svgIcons = document.querySelectorAll(".grid-video svg");

  svgIcons.forEach((icon) => {
    // Add a click event listener to each SVG icon
    icon.addEventListener("click", (event) => {
      // Find the nearest video element within the same grid item
      const video = icon.closest(".grid-video").querySelector("video");

      if (video) {
        // Toggle play and pause
        if (video.paused) {
          video.play();
          // icon.style.fill = "rgba(255,255,255,1)";
          icon.style.display = "none";
          video.setAttribute("controls", "controls");
        } else {
          video.pause();
          // icon.style.fill = "rgba(255,255,255,0.51)";
          icon.style.display = "block";
          // video.setAttribute("controls", "controls");
          video.removeAttribute("controls");
        }
      }
    });
  });
});

$(document).ready(function () {
  if (screen.width <= 767) {
    $(".video-grid .grid").slick({
      dots: false,
      arrows: true,
      loop: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      centerMode: true,
      autoplaySpeed: 3000,
    });
  }


  $(".js-home-video-player").on("click", function () {
    let video = this; // Target the video element itself
  
    // Request fullscreen
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) { // Safari
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) { // IE11
      video.msRequestFullscreen();
    }
  });
  
});

$(window).on("resize", function () {
  $(".video-grid .grid").slick("setPosition");
  if (screen.width >= 768) {
    $(".video-grid .grid").unslick();
    $(".video-grid .grid").slick("setPosition");
  }
});
